/****************************************************************************
 * COPYRIGHT (c) 2025 Harman Connected Services
 *
 * All rights reserved
 *
 * This software embodies materials and concepts which are
 * confidential to Ignite Product and is made available solely
 * pursuant to the terms of a written license agreement with
 * Ignite Product.
 *
 * Designed and Developed by Harman International Industries, Inc.
 ***************************************************************************/

export const FETCH_ADDITIONAL_DOCUMENT_REQUEST='FETCH_ADDITIONAL_DOCUMENT_REQUEST';
export const FETCH_ADDITIONAL_DOCUMENT_SUCCESS='FETCH_ADDITIONAL_DOCUMENT_SUCCESS';
export const FETCH_ADDITIONAL_DOCUMENT_FAILURE='FETCH_ADDITIONAL_DOCUMENT_FAILURE';
export const FETCH_DELETE_ADDITIONAL_DOCUMENT_REQUEST='FETCH_DELETE_ADDITIONAL_DOCUMENT_REQUEST';
export const FETCH_DELETE_ADDITIONAL_DOCUMENT_SUCCESS='FETCH_DELETE_ADDITIONAL_DOCUMENT_SUCCESS';
export const FETCH_DELETE_ADDITIONAL_DOCUMENT_FAILURE='FETCH_DELETE_ADDITIONAL_DOCUMENT_FAILURE';